import { useDispatch } from 'react-redux';
import React, { useLayoutEffect } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { showFooter, hideFooter } from 'js/components/main/Footer/store/actions';

import style from './PageLoader.scss';

export const PageLoader = () => {
    const translate = useTranslations();
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        dispatch(hideFooter());

        return () => {
            dispatch(showFooter());
        };
    }, [dispatch]);

    return (
        <div className={style.pageLoaderContainer}>
            <p className={style.pageLoaderText}>{translate('playtech.mobile.system.page-loader.text')}</p>
        </div>
    );
};
